var map = {
	"./wimmelbild.svg": 8355,
	"./wimmelbild_blumen-1.png": 9444,
	"./wimmelbild_blumen-2.png": 1347,
	"./wimmelbild_blumen-3.png": 921,
	"./wimmelbild_blumen-4.png": 715,
	"./wimmelbild_fahrrad-1.png": 1021,
	"./wimmelbild_fahrrad-2.png": 6811,
	"./wimmelbild_fahrrad-3.png": 8234,
	"./wimmelbild_fahrrad-4.png": 7589,
	"./wimmelbild_katzen-1.png": 9309,
	"./wimmelbild_katzen-2.png": 4099,
	"./wimmelbild_katzen-3.png": 5379,
	"./wimmelbild_katzen-4.png": 6464,
	"./wimmelbild_muell-1.png": 5909,
	"./wimmelbild_muell-2.png": 5079,
	"./wimmelbild_muell-3.png": 8829,
	"./wimmelbild_muell-4.png": 1224,
	"./wimmelbild_roller-1.png": 2434,
	"./wimmelbild_roller-2.png": 2587,
	"./wimmelbild_roller-3.png": 7207,
	"./wimmelbild_roller-4.png": 694,
	"./wimmelbild_voegel-1.png": 1394,
	"./wimmelbild_voegel-2.png": 4947,
	"./wimmelbild_voegel-3.png": 2853,
	"./wimmelbild_voegel-4.png": 1205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 944;